// src/utils/apiFetch.ts
const api_url = process.env.REACT_APP_API_BASE_URL || '';

export async function apiFetch(url: string, options: RequestInit = {}) {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${api_url}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      'X-AUTH-TOKEN': token || '',
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/';  // redirige al login
  }

  return response;
}